// extracted by mini-css-extract-plugin
export default {"centredOnScreen":"styles_centredOnScreen__NFT0R"};